import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';

// 與當前頁面同域的 API 前綴（生产：www.newoceanmachine.com/jeecg-boot 由 Nginx 反代；避免 .com 頁面直連 .top 觸發 CORS）
// 開發：config/index.js 中 proxy 將 /jeecg-boot 轉發到後端
const service = axios.create({
  baseURL: '/jeecg-boot',
  timeout: 10000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['X-Access-Token'] = token;
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    // 如果返回的状态码不是200，说明接口请求失败
    if (res.code !== 200) {
      // 处理特定的错误码
      if (res.code === 401) {
        // token过期，需要重新登录
        localStorage.removeItem('token');
        // 可以在这里添加重定向到登录页的逻辑
      }
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    return res;
  },
  error => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

// 将axios实例挂载到Vue原型上
Vue.use(VueAxios, service);

export default service;



// WEBPACK FOOTER //
// ./src/api/config.js